import * as React from 'react';
import Table from './Table';
import ManagerBase from '../../../Employee/Profile/ManagerFor/Manager';

export default class Manager extends ManagerBase {

    getTable(units: any) {
        return (<Table employee={this.props.employee} units={units} />);
    }
}